import Config from 'utils/config'


const getSameURLWithChangedLanguage = ({ url, language }) => {
  let urlTail = getUrlTail(url)
  let newURL = Config.getConfig().site.path + `/${language}${urlTail}`
  return newURL
}

const getSameURLWithChangedRegion = ({ url, regionCode }) => {
  let urlHead = getUrlHead(url)
  let urlTail = getUrlTail(url)

  let newURL = ''
  newURL += urlHead
    .split('/')
    .splice(0, 3)
    .join('/')
  newURL += `/${regionCode}/`
  newURL += urlTail
    .split('/')
    .splice(2)
    .join('/')
  return newURL
}

const getUrlHead = url => {
  let urlParts = url.split('/')
  let head = urlParts.reduce((prevVal, actVal, index) => {
    let returningVal = prevVal

    if (index < 4 && index !== 0) {
      returningVal = `${prevVal}/${actVal}`
    }
    return returningVal
  }, '')
  return head
}
const getUrlTail = url => {
  let urlParts = url.split('/')
  let tail = urlParts.reduce((prevVal, actVal, index) => {
    let returningVal = prevVal
    if (index > 2) {
      returningVal = `${prevVal}/${actVal}`
    }
    return returningVal
  }, '')
  return tail
}

const getLevelDetailLink = ({ url, level }) => {
  let urlHead = getUrlHead(url)
  switch (level) {
  case 0:
    return `${urlHead}/group-detail/0`
  case 1:
    return `${urlHead}/group-detail/1`
  case 2:
    return `${urlHead}/group-detail/2`
  case 3:
    return `${urlHead}/group-detail/3`
  default:
    return '/404'
  }
}

const getPanelDimensionLink = ( url, dimension ) => {
  let urlHead = getUrlHead(url)
  switch (dimension) {
  case 0:
    return `${urlHead}/group-detail/0`
  case 1:
    return `${urlHead}/group-detail/1`
  case 2:
    return `${urlHead}/group-detail/2`
  case 3:
    return `${urlHead}/group-detail/3`
  default:
    return '/404'
  }
}

const getIndicatorDetailLink = ({ url, indicator }) => {
  let urlHead = getUrlHead(url)
  return `${urlHead}/indicator-detail/${indicator}`
}

const getIndicatorDetailLinkEx = ({ url, indicator }) => {
  let urlHead = getUrlHead(url)
  return `${urlHead}/indicator-evo/${indicator}`
}

const getLayerFromURL = url => {
  if (url.split('/').length > 4) {
    let currentPageName = getCurrentPageName(url)
    switch (currentPageName) {
    case 'dashboard':
      return 1
    case 'group-detail':
      return 2
    case 'indicator-detail':
      return 3
    default:
      return 0
    }
  } else if (url.split('/').length > 3) {
    return 'methodology'
  } else {
    return 0
  }
}

const getCurrentPageName = url => {
  let urlParts = url.split('/')
  let currentPageName = urlParts[4]
  return currentPageName
}

const getLevelFromURL = url => {
  let urlParts = url.split('/')
  let level = urlParts[5]
  level = Number(level)
  return level
}

const getIndicatorFromURL = url => {
  let indicator = Number(getLevelFromURL(url))
  return indicator
}

const getMethodologyLink = url => {
  const urlHead = getUrlHead(url)
  const partialHead = urlHead
    .split('/')
    .splice(0, 3)
    .join('/')
  return `${partialHead}/panels-development-methodology`
}

const getHomeLink = url => {
  const urlHead = getUrlHead(url)
  let homeLink = urlHead
    .split('/')
    .splice(0, 3)
    .join('/')
  if ( !Config.getProperty( "enable_region_change", true ) ) {
    homeLink = homeLink + "/ES21"
  }
  return homeLink
}

const getReportPanelLink = (url, region_code) => {
  const urlHead = getUrlHead(url);
  if (region_code === undefined ) {
    return `${urlHead}/report-table`;
  } else {
    const partialHead = urlHead
      .split('/')
      .splice(0, 3)
      .join('/');
    return `${partialHead}/${region_code}/report-table`;
  }
}

const APPURL = {
  getSameURLWithChangedLanguage,
  getSameURLWithChangedRegion,
  getUrlHead,
  getLevelDetailLink,
  getPanelDimensionLink,
  getIndicatorDetailLink,
  getIndicatorDetailLinkEx,
  getLayerFromURL,
  getCurrentPageName,
  getLevelFromURL,
  getIndicatorFromURL,
  getMethodologyLink,
  getHomeLink,
  getReportPanelLink
}

export default APPURL



// WEBPACK FOOTER //
// ./src/utils/app/urls.js